require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.map");

require("core-js/modules/es.number.constructor");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "vant/es/toast/style", "vant/es/toast"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("vant/es/toast/style"), require("vant/es/toast"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.style, global.toast);
    global.deviceTestDetail = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _style, _toast) {
  "use strict";

  var _interopRequireDefault = require("/root/deploy/iot-product-tool/node_modules/@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _toast = _interopRequireDefault(_toast);
  var _default = {
    name: 'XiazengDeviceTestDetail',
    data: function data() {
      var ossHostPond = this.$config.base.ossHostPond;
      return {
        ossPondHost: ossHostPond,
        // 设备IMEI
        imei: '',
        // 设备编号(展示用)
        displayNum: '',
        // 设备详情(接口数据)
        device: {},
        // 开合记录弹框
        showRecordModal: false,
        // 当前查看的记录: gravity=重力感应器 limit=底部限位
        activeTab: 'gravity',
        // 拍照图片预览
        showPreviewImg: false
      };
    },
    computed: {
      // 信号强度, 无值展示 -
      displaySignal: function displaySignal() {
        var value = this.device.signal;
        return value === null || value === undefined || value === '' ? '-' : value;
      },
      // 重力感应器状态: 0=闭合受力(拉紧) 1=断开不受力(放松)
      gravityStateText: function gravityStateText() {
        var status = this.device.gravityStatus;
        if (status === null || status === undefined) return '-';
        return this.formatStateTime(status === 0 ? '闭合' : '打开', this.device.gravityLastEdgeTime);
      },
      // 底部限位器状态: 0=闭合(到顶) 1=断开(未到顶)
      limitStateText: function limitStateText() {
        var status = this.device.limitStatus;
        if (status === null || status === undefined) return '-';
        return this.formatStateTime(status === 0 ? '闭合' : '打开', this.device.limitLastEdgeTime);
      },
      // 拍照时间文案
      photoTimeText: function photoTimeText() {
        var time = this.device.lastUpdateTime;
        return time ? "".concat(this.formatTime(time), "\u62CD\u6444\u7684\u7684\u7167\u7247") : '拍摄的照片';
      },
      // 当前选中的开合记录(SensorEdgeView, 按时间倒序)
      currentRecords: function currentRecords() {
        var _this = this;

        var edges = (this.activeTab === 'gravity' ? this.device.gravityEdges : this.device.limitEdges) || [];
        return edges.map(function (edge) {
          return {
            text: edge.toValue === 0 ? '闭合' : '打开',
            time: _this.formatTime(edge.timestamp)
          };
        });
      }
    },
    created: function created() {
      var vm = this; // 从设备列表页保存的数据中取当前设备IMEI

      var index = vm.$route.query.index;
      var listStr = sessionStorage.getItem('xiazengDeviceTestList') || '[]';
      var list = [];

      try {
        list = JSON.parse(listStr);
      } catch (e) {
        list = [];
      }

      var info = list[Number(index)] || {};
      vm.imei = info.imei || '';
      vm.displayNum = vm.imei;
      vm.loadDeviceDetail();
    },
    methods: {
      // 毫秒时间戳格式化 HH:mm
      formatTime: function formatTime(timestamp) {
        return timestamp ? this.$time.formateTime(timestamp, 'h:f') : '-';
      },
      // 状态文案: 有翻转时间则拼接 闭合(14:31)
      formatStateTime: function formatStateTime(text, timestamp) {
        return timestamp ? "".concat(text, "(").concat(this.formatTime(timestamp), ")") : text;
      },
      // 获取设备详情(含重力感应器/限位器/反转记录/图片)
      loadDeviceDetail: function loadDeviceDetail() {
        var vm = this;
        if (!vm.imei) return;
        vm.$http({
          method: 'GET',
          url: vm.$config.base.XIAZENG_BASE_URL + "xia/factory/parts/device/".concat(vm.imei)
        }).then(function (res) {
          vm.device = res.data || {};
          vm.displayNum = vm.device.imei || vm.imei;
        }).catch(function () {});
      },
      // 下发控制指令: 2=补光灯开 3=补光灯关 4=电机正转 5=电机反转 9=LED闪烁 11=蜂鸣器鸣叫 12=单独拍照
      dispatch: function dispatch(action) {
        var vm = this;

        if (!vm.imei) {
          (0, _toast.default)('设备IMEI为空');
          return;
        } // action=4/5/9/11 需传持续秒数, 固定5秒


        var needSecond = [4, 5, 9, 11].indexOf(action) > -1;
        var query = needSecond ? "action=".concat(action, "&second=5") : "action=".concat(action);

        var toast = _toast.default.loading({
          message: '指令下发中...',
          forbidClick: true,
          duration: 0
        });

        vm.$http({
          method: 'POST',
          url: vm.$config.base.XIAZENG_BASE_URL + "xia/factory/parts/ctr/".concat(vm.imei, "?").concat(query)
        }).then(function () {
          toast.clear();
          (0, _toast.default)('指令已下发'); // 稍后刷新设备详情, 同步状态/图片

          setTimeout(function () {
            vm.loadDeviceDetail();
          }, 3000);
        }).catch(function () {
          toast.clear();
        });
      },
      // 1.指示灯: LED闪烁(action=9, 5秒)
      onclickLightTest: function onclickLightTest() {
        this.dispatch(9);
      },
      // 2.电机: 反转(action=5, 5秒)
      onclickMotorReverse: function onclickMotorReverse() {
        this.dispatch(5);
      },
      // 2.电机: 正转(action=4, 5秒)
      onclickMotorForward: function onclickMotorForward() {
        this.dispatch(4);
      },
      // 3.补光灯: 关闭(action=3)
      onclickFillLightOff: function onclickFillLightOff() {
        this.dispatch(3);
      },
      // 3.补光灯: 开启(action=2)
      onclickFillLightOn: function onclickFillLightOn() {
        this.dispatch(2);
      },
      // 4.蜂鸣器: 鸣叫(action=11, 5秒)
      onclickBuzzerTest: function onclickBuzzerTest() {
        this.dispatch(11);
      },
      // 5.摄像头: 单独拍照上传(action=12)
      onclickCameraTest: function onclickCameraTest() {
        this.dispatch(12);
      },
      // 去查看 - 预览最近一次拍照上传的图片
      onclickViewPhoto: function onclickViewPhoto() {
        if (!this.device.imageUrl) {
          (0, _toast.default)('暂无拍摄照片');
          return;
        }

        this.showPreviewImg = true;
      },
      // 点击更多 - 打开开合记录弹框
      onclickMore: function onclickMore(tab) {
        this.activeTab = tab;
        this.showRecordModal = true;
      }
    }
  };
  _exports.default = _default;
});